import { Component, OnInit, NgZone } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService, WMAIApiService, AppInformationService } from '../core/services/';
import { ActivatedRoute, Router } from '@angular/router';
import { WgisService } from '../wgis/wgis.service';
import { Angulartics2 } from 'angulartics2';
import { RouterExtService } from '../core';
import { AngularFireAuth } from '@angular/fire/auth';
import { auth as fireApp } from 'firebase/app';
import { environment } from '../../environments/environment';
import { HttpParams } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { JwtHelperService } from '@auth0/angular-jwt';

declare var cordova;
declare var universalLinks;
declare var facebookConnectPlugin;
declare var TwitterConnect;
declare var window;

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
})
export class AuthComponent implements OnInit {

  returnUrl: string;
  isfirstlogin: false;
  isnotactive: boolean;

  isIOS: boolean = false;

  helper = new JwtHelperService();

  constructor(
    public afAuth: AngularFireAuth,
    private auth: AuthService,
    private router: Router,
    private wgisservice: WgisService,
    private angulartics2: Angulartics2,
    private routerextservice: RouterExtService,
    private wmaiservice: WMAIApiService,
    private appservice: AppInformationService,
    private activatedroute: ActivatedRoute,
    private zone: NgZone,
    private translate: TranslateService
  ) {

    this.angulartics2.eventTrack.next({
      action: 'logIn',
      properties: { label: 'AuthLogin' },
    });

    this.wgisservice.setMapInvisible();
    if(this.appservice.iAmMobile()){
      this.isIOS = window.device.platform == 'iOS';
    }
  }

  logIn(form: NgForm) {
    if (!form.valid) {
      return false;
    }

    this.auth.signIn(form.value.username, form.value.password);
  }

  ngOnInit() {
    this.auth.userisfirstlogin.subscribe((response) => {
      if (response) {
        this.wmaiservice.updateFirstLogin(Number(localStorage.getItem('id'))).subscribe(() => {
          localStorage.setItem('isfirstlogin', 'false');
          this.router.navigate(['/settings/', localStorage.getItem('username')]);
        });
      } else {
        this.router.navigateByUrl(this.routerextservice.getPreviousUrl().toString().indexOf('login') > 0 ? '/' : this.routerextservice.getPreviousUrl());
      }
    });
  }

  /**
   * socialLogin, effettua il login in base al parametro passato [google, facebook, twitter]
   * @param  {string} provider
   */
  socialLogin(provider: string) {
    if (provider === 'google') {
      if (this.appservice.iAmMobile()) {
        (<any>window).plugins.googleplus.login({}, (userData) =>{
          // if (environment.production === false) console.log("Googel success", userData);
          const data = {email: userData.email, displayName: userData.displayName, uid: userData.userId}
          this.auth.socialLogin(data, data.uid, 'social');
        }, (err) => {
          alert("[Login] - Error logging in code: " + JSON.stringify(err));
        })
      } else {
        this.afAuth.auth.signInWithPopup(new fireApp.GoogleAuthProvider())
          .then(el => {
            // if (environment.production === false) console.table(el);
            this.auth.socialLogin(el.user, el.user.uid, 'social');
          });
      }
    }
    if (provider === 'facebook') {
      if (this.appservice.iAmMobile()) {
        facebookConnectPlugin.getLoginStatus((checkStatus) => {
          // if (environment.production === false) console.log("check status", checkStatus);
          if(checkStatus.status == 'connected'){
            facebookConnectPlugin.api("/me?fields=email,name", ["public_profile", "email"],
            (userData) => {
                //API success callback
                const data = {email: userData.email, displayName: userData.name, uid: userData.id}
                this.auth.socialLogin(data, data.uid, 'social');
            },
            (err) => {
                //API error callback
                alert("[VerifyCredentials] - Error: " + JSON.stringify(err));
            });
          } else {
            // if (environment.production === false)console.log("go login");
            facebookConnectPlugin.login(["public_profile", "email"], (result) => {
              // if (environment.production === false)  console.log("result facebook", result);
              facebookConnectPlugin.api("/me?fields=email,name", ["public_profile", "email"],
                (userData) => {
                    //API success callback
                    const data = {email: userData.email, displayName: userData.name, uid: userData.id}
                    this.auth.socialLogin(data, data.uid, 'social');
                },
                (err) => {
                    //API error callback
                    alert("[VerifyCredentials] - Error: " + JSON.stringify(err));
                });
            }, (err) => {
              alert("[Login] - Error logging in: " + JSON.stringify(err));
            })
          }
        }, (err) => {
          alert("[Check Login] - Error check logging: " + JSON.stringify(err))
        })
      } else {
        this.afAuth.auth.signInWithPopup(new fireApp.FacebookAuthProvider())
          .then(el => {
            // this.auth.socialLogin(el.user.email, el.user.displayName, el.user.uid, provider);
            // if (environment.production === false) console.table(el);
            this.auth.socialLogin(el.user, el.user.uid, 'social');
          }).finally(
          );
      }
    }
    if (provider === 'twitter') {
      if (this.appservice.iAmMobile()) {
        TwitterConnect.login((result) => {
          // if (environment.production === false) console.log('[Login] - Successful login!');
            TwitterConnect.verifyCredentials(
              /*Endpoint arguments*/
              {"include_entities": false,
              "skip_status" : true,
              "include_email": true},
            
              /*Callback functions*/
              (userData) => {
                // if (environment.production === false) console.log('[VerifyCredentials] - Success!');
                const data = {email: userData.email, displayName: userData.name, uid: userData.id}
                this.auth.socialLogin(data, data.uid, 'social');
              }, (err) => {
                alert('[VerifyCredentials] - Error: ' +  err);
              }
            );
          },(err) => {
            alert('[Login] - Error logging in: ' + err);
          }
        );
      } else {
        this.afAuth.auth.signInWithPopup(new fireApp.TwitterAuthProvider())
          .then(el => {
            // if (environment.production === false) console.table(el);
            this.auth.socialLogin(el.user, el.user.uid, 'social');
          });
      }
    }
  }

  appleLogin(){
    window.cordova.plugins.SignInWithApple.signin(
      { requestedScopes: [0, 1] },
      (userData) => {
        let jwt_data = this.helper.decodeToken(userData.identityToken);
        const data = {email: jwt_data.email, displayName: userData.fullName.givenName || '', uid: userData.user}
        this.auth.socialLogin(data, data.uid, 'social');
      },
      (err) => {
        console.error(err)
        alert(JSON.stringify(err))
      }
    )
  }

  loginIdm() {
    const url = environment.authEndPoint.idmUrl;
    if (this.appservice.iAmMobile()) {
      // universalLinks.subscribe('loginIDM', (url) => {
      //   this.handleOpenURL(url);
      // });
      // cordova.InAppBrowser.open(url, '_blank');
      let browser = cordova.InAppBrowser.open(url, '_blank', "location=yes");
      browser.addEventListener('loadstart', (browserEvent) => {
        // if (environment.production === false) console.log("Browser event", browserEvent);
        if(browserEvent.url.startsWith(environment.authEndPoint.responseUrl)){
          this.handleOpenURL(browserEvent.url);
          browser.close();
          browser = undefined;
        }
      })
      // browser.addEventListener('exit', (exitEvent) => {
      //   browser = undefined;
      // })
    } else {
      window.location.href = url;
    }
  }

  handleOpenURL(url:string) {
    // if (environment.production === false) console.log("handle", url);
      let code;
      if (url.includes('?')) {
        const httpParams = new HttpParams({ fromString: url.split('?')[1] });
        code = httpParams.get('code');
        this.zone.run(() => {
          if(code){
            this.auth.loginIdm(code);
          } else {
            alert(this.translate.instant('auth.messages.redirect_failed'));
          }
        })
      } else {
        alert(this.translate.instant('auth.messages.redirect_error'))
      }
      
      // universalLinks.unsubscribe('loginIDM');
  };
}
